export type RedirectToRegisteredUserParams = {
  ladyId?: string;
  isLoginFromRegistration?: boolean;
};

export const redirectToRegisteredUser = ({
  isLoginFromRegistration,
  ladyId,
}: RedirectToRegisteredUserParams = {}) => {
  const id = ladyId || window.location.href.match(/\/lady\/id(\d+)/)?.[1];

  if (isLoginFromRegistration && id) {
    window.location.href = `/#!THANKYOU;${id}`;
    return;
  }

  if (isLoginFromRegistration && !id) {
    window.location.href = "/#!THANKYOU;";
    return;
  }

  if (id) {
    window.location.href = "/#!VIEWLADYPAGE;" + id;
  } else {
    window.location.href = "/#!NEWSFEED;";
  }

  // window.location.reload();
};
